module.exports = __webpack_public_path__ + "static/media/funktionelles-training-desktop.4b014db8.jpg";